import { hwFetch } from '@src/utils/fetch';

export const pclogout = async (params) => {
  try {
    const url = `/sso/v1/pclogout`;
    let res = await fetch(url, {method: 'POST'})
    return 200;
  } catch (error) {
    return false;
  }

}
// 常见问题列表
export const hotsQuestions = async () => {
  try {
    const url = `/welink/rest/manage/service/wecode/robots/hots?domain=${encodeURIComponent("开放平台")}`;
    let res = await fetch(url, {method: 'GET'})
    return res;
  } catch (error) {
    return false;
  }
}
//输入框搜索
export const getSuggestions = async (params) => {
  try {
    const url = `/welink/rest/manage/service/wecode/robots/suggestions`;
    const res = await fetch(url, {
      method: 'POST',
      body: params
    });
    return res;
  } catch (error) {
    return false;
  }

}

// 自动回复接口
export const getResponse = async (params) => {
  try {
    const url = `/welink/rest/manage/service/wecode/robots/questions`;
    const res = await hwFetch(url, {
      method: 'POST',
      body: params
    });
    return res;
  } catch (error) {
    return false;
  }

}

// 创建客服会话
export const createSession = async (params) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/create_session`;
    const res = await fetch(url, {
      method: 'POST',
      body: params
    });
    return res;
  } catch (error) {
    return false;
  }

}

// 获取排队详情
export const getQueue = async (icsId) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/get_queue?icsId=${icsId}`;
    let res = await fetch(url, {method: 'GET'})
    return res;
  } catch (error) {
    return false;
  }

}

// 取消排队
export const cancelQueue = async (icsId) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/cancel_queue?icsId=${icsId}`;
    let res = await fetch(url, {method: 'GET'})
    return res;
  } catch (error) {
    return false;
  }

}


// 获取会话接口
export const getSession = async (params) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/get_session`;
    const res = await fetch(url, {
      method: 'POST',
      body: params
    });
    return res;
  } catch (error) {
    return false;
  }

}

// 客服发送消息接口
export const sendMessage = async (params) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/send_message`;
    const res = await fetch(url, {
      method: 'POST',
      body: params
    });
    return res;
  } catch (error) {
    return false;
  }

}

// 轮询接口
export const getEvent = async (icsId) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/get_event?icsId=${icsId}`;
    let res = await fetch(url, {method: 'GET'})
    return res;
  } catch (error) {
    return false;
  }

}


// 用户挂机接口
export const dropCall = async (icsId) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/drop_call?icsId=${icsId}`;
    let res = await fetch(url, {method: 'DELETE'})
    return res;
  } catch (error) {
    return false;
  }

}


//评价
export const appraise = async (params) => {
  try {
    const url = `/welink/rest/manage/service/wecode/ihelp/appraise`;
    const res = await fetch(url, {
      method: 'POST',
      body: params
    });
    return res;
  } catch (error) {
    return false;
  }

}

// 获取白名单列表
export const getWhiteList = ()=>{
  const url = '/wecode/service/white/config/list'
  return fetch(url,{
    method:'GET'
  })
}

